import { createUserObject } from 'redux/helper/objectMapper'

export default (state, action) => {
  const { userData, authenticated } = action.payload
  const user = userData && createUserObject(userData)
  return { ...state, authenticated, user }
}
